import { isDefined } from './helpers';
import { Splide } from '@splidejs/splide';

export function initTemoignage()
{
    const slider_temoignage_wrapper = document.querySelector('.section-temoignage-slider');
    
    if(!isDefined(slider_temoignage_wrapper)) return;

    let slider_temoignage = new Splide(slider_temoignage_wrapper, {
        type: "loop",
        speed : "2200",
        interval : "2500",
        pagination:true,
        autoplay: true,
        waitForTransition: false,
        arrows: false,
        pauseOnHover: true,
        pauseOnFocus: false,
        mediaQuery: 'min',
        breakpoints: {
            1700: {
                autoplay: false
            }
        }
    })

    slider_temoignage.mount();

    const nextButton = document.querySelector('.section-temoignage .section-view-image-slider-button-next');
    if(!isDefined(nextButton)) return;
    nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        slider_temoignage.go('>');
    }.bind(this));

}